// Apple ID登录服务
class AppleAuthService {
  constructor() {
    this.user = null;
    this.token = null;
    this.listeners = [];
  }

  // 添加状态变化监听器
  addListener(callback) {
    this.listeners.push(callback);
  }

  // 移除监听器
  removeListener(callback) {
    this.listeners = this.listeners.filter(listener => listener !== callback);
  }

  // 通知所有监听器
  notifyListeners() {
    this.listeners.forEach(callback => callback(this.user, this.token));
  }

  // 设置用户信息
  setUser(user, token) {
    this.user = user;
    this.token = token;
    this.saveToStorage();
    this.notifyListeners();
  }

  // 清除用户信息
  clearUser() {
    this.user = null;
    this.token = null;
    this.clearStorage();
    this.notifyListeners();
  }

  // 获取当前用户
  getCurrentUser() {
    return this.user;
  }

  // 获取当前token
  getCurrentToken() {
    return this.token;
  }

  // 检查是否已登录
  isLoggedIn() {
    return !!this.user && !!this.token;
  }

  // 保存到本地存储
  saveToStorage() {
    try {
      localStorage.setItem('apple_user', JSON.stringify(this.user));
      localStorage.setItem('apple_token', this.token);
    } catch (error) {
      console.error('Failed to save user data to localStorage:', error);
    }
  }

  // 从本地存储加载
  loadFromStorage() {
    try {
      const userData = localStorage.getItem('apple_user');
      const token = localStorage.getItem('apple_token');
      
      if (userData && token) {
        this.user = JSON.parse(userData);
        this.token = token;
        return true;
      }
    } catch (error) {
      console.error('Failed to load user data from localStorage:', error);
    }
    return false;
  }

  // 清除本地存储
  clearStorage() {
    try {
      localStorage.removeItem('apple_user');
      localStorage.removeItem('apple_token');
    } catch (error) {
      console.error('Failed to clear user data from localStorage:', error);
    }
  }

  // 验证token（这里需要你的后端API）
  async validateToken(token) {
    try {
      const response = await fetch('/api/auth/validate-apple-token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token })
      });

      if (response.ok) {
        const data = await response.json();
        return data.valid;
      }
    } catch (error) {
      console.error('Token validation failed:', error);
    }
    return false;
  }

  // 提交投票（需要登录）
  async submitVote(voteData) {
    if (!this.isLoggedIn()) {
      throw new Error('User must be logged in to vote');
    }

    try {
      const response = await fetch('/api/votes/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify({
          ...voteData,
          userId: this.user.email,
          provider: 'apple'
        })
      });

      if (response.ok) {
        const result = await response.json();
        return result;
      } else {
        throw new Error('Failed to submit vote');
      }
    } catch (error) {
      console.error('Vote submission failed:', error);
      throw error;
    }
  }

  // 获取投票结果
  async getVoteResults(voteId) {
    try {
      const response = await fetch(`/api/votes/${voteId}/results`);
      
      if (response.ok) {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.error('Failed to get vote results:', error);
    }
    return null;
  }
}

// 创建单例实例
const appleAuthService = new AppleAuthService();

export default appleAuthService;
